"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraMode = exports.EditorModesSchema = exports.EditorModes = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
var EditorModes;
(function (EditorModes) {
    EditorModes["schematic"] = "schematic";
    EditorModes["code"] = "code";
    EditorModes["pcb"] = "pcb";
    EditorModes["doc"] = "doc";
})(EditorModes || (exports.EditorModes = EditorModes = {}));
exports.EditorModesSchema = zod_1.default.nativeEnum(EditorModes);
var CameraMode;
(function (CameraMode) {
    CameraMode["two_d"] = "two_d";
    CameraMode["three_d"] = "three_d";
})(CameraMode || (exports.CameraMode = CameraMode = {}));
//# sourceMappingURL=editor.js.map